import React from 'react';
import { Modal, PillButton, Row, Stack, Text } from 'library/ui';
import { BookResult } from './models';

export function BookResultModal({
    workerName,
    result,
    onClose,
}: {
    workerName: string;
    result: BookResult;
    onClose: () => void;
}) {
    const titles = {
        booked: 'Added to Schedule',
        hiring_group: 'Confirmation Needed',
        unavailable: 'No Longer Available',
        not_eligible: 'Cannot Book Right Now',
        sponsored: 'Fingerprint Sponsorship Sent',
        review_initiated: 'Review In Process',
        reported: 'Saved',
    };
    const messages = {
        booked:
            result.reason === 'last_minute'
                ? `${workerName} has been added to your schedule for their later shifts. Because their soonest shift is last minute, we need them to confirm they can make it. We've sent them a request to accept and will add them to that shift as soon as they do.`
                : `${workerName} has been added to your schedule successfully!`,
        hiring_group:
            result.reason === 'last_minute'
                ? `Because this shift is last minute, we need ${workerName} to confirm they can make it. We've sent them a request to accept and will add them to your schedule as soon as they do.`
                : `Because ${workerName} applied more than a week ago, we need them to confirm they're still available. We've sent them a request to accept and will add them to your schedule as soon as they do.`,
        unavailable: `Unfortunately, ${workerName} is no longer available for these shifts.`,
        not_eligible: `You cannot currently book ${workerName} based on their Clearinghouse status. We've saved what you found.`,
        sponsored: `We've contacted ${workerName} with instructions to schedule their fingerprint appointment. You can track their screening status here or on the My Staff page as it progresses.`,
        review_initiated: `We've noted the review is in process. When ${workerName}'s screening comes back as Eligible, return to Tandem to book them.`,
        reported: `We've saved what you found so our records stay up to date. You cannot currently book ${workerName}.`,
    };
    return (
        <Modal title={titles[result.status]} onClose={onClose} width={440}>
            <Stack gap="md">
                <Text>{messages[result.status]}</Text>
                <Row justify="end" fullWidth>
                    <PillButton onClick={onClose}>Done</PillButton>
                </Row>
            </Stack>
        </Modal>
    );
}
